export default function createReducer(initialState, handlers = {}) {
  return (state = initialState, action) => {
    const handler = (action && action.type) ? handlers[action.type] : undefined;
    return handler ? handler(state, action) : state;
  };
}
